import React, { useState, useContext } from "react";
import {
  Box,
  TextField,
  Button,
  Paper,
  Typography,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { useSnackbar } from "../utils/snackbar";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useContext(AuthContext);
  const { showAlert } = useSnackbar();

  const submit = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const res = await axios.post(
        "https://backend-mtaani.onrender.com/api/auth/login",
        { email, password }
      );

      login(res.data.user, res.data.token);
      showAlert("Logged in successfully", "success");
    } catch (err) {
      showAlert(
        err.response?.data?.message || "Login failed",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)",
      }}
    >
      <Paper
        elevation={8}
        sx={{
          width: 420,
          p: 4,
          borderRadius: 3,
        }}
      >
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <LockOutlinedIcon
            sx={{
              fontSize: 48,
              bgcolor: "primary.main",
              color: "white",
              borderRadius: "50%",
              p: 1,
              mb: 1,
            }}
          />
          <Typography variant="h5" fontWeight={600}>
            Admin Login
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Sign in to continue
          </Typography>
        </Box>

        <TextField
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          fullWidth
          sx={{ mb: 3 }}
          onKeyDown={(e) => e.key === "Enter" && submit()}
        />

        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={submit}
          disabled={loading}
          sx={{
            height: 48,
            fontWeight: 600,
            borderRadius: 2,
          }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Login"
          )}
        </Button>
      </Paper>
    </Box>
  );
}
